import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { AboutMe } from './components/AboutMe';
import { Services } from './components/Services';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { Process } from './components/Process';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { LegalModal } from './components/LegalModal';
import { CookieBanner } from './components/CookieBanner';
import type { LegalPage } from './components/LegalModal';
export function App() {
  const [activeLegalPage, setActiveLegalPage] = useState<LegalPage>(null);
  return <div className="min-h-screen bg-stone-50 font-sans selection:bg-violet-200 selection:text-violet-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoints data-id="element-4" />
        <AboutMe data-id="element-5" />
        <Benefits data-id="element-6" />
        <Services data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Process data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer onOpenLegal={setActiveLegalPage} data-id="element-11" />
      <WhatsAppButton data-id="element-12" />
      <LegalModal activePage={activeLegalPage} onClose={() => setActiveLegalPage(null)} data-id="element-13" />
      <CookieBanner onOpenCookiePolicy={() => setActiveLegalPage('cookies')} data-id="element-14" />
    </div>;
}